import type { ReactNode } from "react";

/** Place the viewer's version chip beside the plain file title. */
export function FileVersionTitle({
  setContainer,
  children,
}: {
  setContainer: (element: HTMLDivElement | null) => void;
  children: ReactNode;
}) {
  return (
    <div className="flex min-w-0 items-center gap-2">
      <div className="min-w-0">{children}</div>
      <div ref={setContainer} className="shrink-0 empty:hidden" />
    </div>
  );
}
